// Dashboard · tiny presentational primitives shared across the tabs.
import React from "react";
import { Card } from "../ui/card";
import { Label } from "../ui/label";

export function StatCard({ icon: Icon, label, value, testid }) {
  return (
    <Card className="card-elevated p-5" data-testid={testid}>
      <div className="flex items-center justify-between">
        <div className="overline">{label}</div>
        <Icon className="w-4 h-4 text-accent" />
      </div>
      <div className="font-display text-4xl mt-3">{value}</div>
    </Card>
  );
}

export function Field({ label, children }) {
  return (
    <div>
      <Label className="text-xs uppercase tracking-widest text-muted-foreground">{label}</Label>
      <div className="mt-2">{children}</div>
    </div>
  );
}
